import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DatatableClickEvent } from '@basis/angular-components';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SelectItem } from 'primeng/primeng';
import { BaseStepComponent } from "../../../base/base-step.component";
import { environment } from 'environments/environment';
import { PadraoService } from '../../../service/padrao.service';

@Component({
    selector: 'central-notificacao-etapa2',
    templateUrl: 'central-notificacao-etapa2.component.html'
})
export class CrudCentralNotificacaoEtapa2Component extends BaseStepComponent {
    @Input() listaSistema:any[] = [];
    @Input() listaPerfil:any[] = [];
    @Input() listaDiasSemana:any[] = [];
    @Input() listaMeses:any[] = [];
    @Input() listaDiasMes:any[] = [];
    @Input() isPerfil: boolean;
    showPerfil: boolean;

    init(){
        this.showPerfil = +this.cadastro.get('tipo_envio').value === 1 || this.isPerfil;
    }
    
    tipoRotina(): string{
        const tipo = +this.cadastro.controls.tipo_rotina.value;
        let data = ''

        switch (tipo) {
            case 2:
                data = 'Rotina Semanal';
                break;
            case 3:
                data = 'Rotina Mensal';
                break;
            default:
                data = 'Data Especifica';
                break;
        }
        return data;
    }
    
}


// WEBPACK FOOTER //
// ./src/app/central-notificacao/crud/etapas/central-notificacao-etapa2.component.ts